import { I18nContextProvider } from 'i18n/I18nProvider';
import * as React from 'react';
import { RouterProvider } from 'react-router';
import { router } from 'router/routes';
import { IPublicSession, userSession } from 'state/session';
import { initAvpAuthentication } from 'utils/auth/avp';
import { useTokenRefresh } from 'hooks/useTokenRefresh';

initAvpAuthentication();

export function App({ ...props }) {
  // Silently refresh the dealer's access token before it expires (incl. PR preview domains).
  useTokenRefresh();

  /** Populate the state with the props coming from the WC */
  React.useLayoutEffect(() => {
    Object.entries(props).forEach(([key, value]) => {
      if (Object.keys(userSession().data).includes(key)) {
        userSession().queue({ [key as keyof IPublicSession]: value });
      }
    });
    userSession().applyQueue();
  }, [props]);

  return (
    <>
      <I18nContextProvider>
        <RouterProvider router={router} />
      </I18nContextProvider>
    </>
  );
}

export default App;
